import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { pageStyles } from "../pages/pageStyles";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div style={pageStyles.fullPageCenter}>Loading…</div>;
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
